module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Page not found","text1":"The page you requested has been deleted or moved.","text2":"You can go to the","text3":"main page"},"ru":{"title":"Страница не найдена","text1":"Запрашиваемая страница удалена или перемещена.","text2":"Вы можете перейти на","text3":"главную страницу"}}')
  delete Component.options._Ctor
}
